import { render, staticRenderFns } from "./SpotlightScoreBadge.vue?vue&type=template&id=36091b38&"
import script from "./SpotlightScoreBadge.vue?vue&type=script&lang=js&"
export * from "./SpotlightScoreBadge.vue?vue&type=script&lang=js&"
import style0 from "./SpotlightScoreBadge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports